import { Tooltip, UIText2, UIText3 } from '@cian/ui-kit';
import {
  IconFunctionalErrorCircle16,
  IconFileEdit16,
  IconFunctionalSuccess16,
  IconFunctionalShow16,
  IconActionLink16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { TProject } from 'shared/types/project';

import * as styles from './ProjectItem.css';

export type TEditData = Pick<TProject, 'id' | 'title' | 'seoPath' | 'description' | 'seoDescription' | 'seoTitle'>;

interface IProjectItemProps extends TProject {
  onClick: (id: number) => void;
  onEditClick: (data: TEditData) => void;
  currentUrl: string;
}

const CIAN_LINK = 'https://www.cian.ru';

export const ProjectItem: React.FC<IProjectItemProps> = ({
  id,
  title,
  description,
  createdAt,
  configCreatedAt,
  hash,
  published,
  seoPath,
  seoDescription,
  seoTitle,
  updatedAt,
  currentUrl,
  onClick,
  onEditClick,
}) => {
  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEditClick({ id, description, seoPath, seoTitle, seoDescription, title });
  };

  const created = React.useMemo(() => new Date(createdAt).toLocaleDateString('en-GB'), [createdAt]);
  const updated = React.useMemo(() => new Date(updatedAt).toLocaleDateString('en-GB'), [updatedAt]);
  const configCreated = React.useMemo(
    () => (configCreatedAt ? new Date(configCreatedAt).toLocaleDateString('en-GB') : '-'),
    [configCreatedAt],
  );

  return (
    <li className={styles['container']} onClick={() => onClick(id)}>
      {published ? <IconFunctionalSuccess16 /> : <IconFunctionalErrorCircle16 />}
      <div className={styles['text']}>
        <span className={styles['inner-text']}>
          <UIText2 display="inline-block">{title}</UIText2>
          <UIText2 display="inline-block" color="black_60">
            ({`${seoPath} - ${seoTitle}`})
          </UIText2>
        </span>
        <UIText3>{description}</UIText3>
      </div>
      <UIText2 textAlign="center">{created}</UIText2>
      <UIText2 textAlign="center">{updated}</UIText2>
      <UIText2 textAlign="center">{configCreated}</UIText2>
      <UIText2 textAlign="center">{hash || '-'}</UIText2>
      <div className={styles['actions']}>
        <Tooltip title="Посмотреть превью">
          <a href={`${currentUrl}/${id}/preview`} target="_blank" rel="noreferrer">
            <IconFunctionalShow16 />
          </a>
        </Tooltip>
        <Tooltip title="Редактировать информацию">
          <IconFileEdit16 onClick={handleEditClick} />
        </Tooltip>
        <Tooltip title="Ссылка на проект">
          <a href={`${CIAN_LINK}/promotions/${seoPath}`} target="_blank" rel="noreferrer">
            <IconActionLink16 />
          </a>
        </Tooltip>
      </div>
    </li>
  );
};
